import initialState from './initialState';
import { reducer as getJournalsReducer } from './getJournals';

const reducers = [getJournalsReducer];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/mood-journal/redux/reducer.js